<div class="min-h-screen mx-auto px-4 flex flex-col"
     *ngIf="config"
     [class.max-w-5xl]="config.screenRatio < 1"
     [class.max-w-xl]="config.screenRatio >= 1"
>
  <div id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo">
  </div>

  <content-block [slug]="'default-theme-top'" id="default-theme-top-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-theme-top'" id="wbm-theme-top-wrapper" [class.hidden]=" ! boothMode"></content-block>

  <div class="grid grid-flow-row gap-4"
       [class.grid-cols-2]="themes.length < 9"
       [class.grid-cols-3]="themes.length >= 9 && themes.length < 16"
       [class.grid-cols-4]="themes.length >= 16"
  >
    <ng-container *ngFor="let theme of themes">
      <div class="relative aspect-square">
        <div class="relative overflow-hidden rounded-lg border-primary aspect-square" [class.theme-selected]="isSelected(theme)" (click)="toggleSelection(theme)">
          <div
            class="absolute min-h-full bg-contain bg-center bg-no-repeat aspect-square z-0"
            [style]="{ 'background-image': 'url(' + getSampleImageUrl(theme) + ') '}"></div>
          <div class="theme-overlay absolute aspect-square top-0 left-0 z-10 w-full">&nbsp;</div>
          <p class="theme-label absolute bottom-2 text-center w-full [text-shadow:_0_0_8px_rgb(0_0_0_)] z-20">{{ theme.label }}</p>
        </div>
      </div>
    </ng-container>
  </div>

  <div id="you-selected-line" i18n>Themes selected {{ countSelected(themes) }} of {{ config.generationSelectionLimit || themes.length }}</div>

  <button
    type="submit"
    class="button-primary disabled:bg-neutral-500 disabled:text-neutral-600"
    [disabled]="formInvalid"
    [routerLink]="['..','capture']"
    i18n
  >Continue</button>
</div>

